<template>
        <div class="model" v-show="loading">
            <div class="box">
                <div>
                    <div class="loader-05"></div>
                </div>
                <p>加载中...</p>
            </div>
        </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false
            }
        },
        created() {
            var that = this;
            this.bus.$on('loading', function(data) {
                that.loading = !!data;
            })
        }
    }
</script>

<style scoped>
    html,body{
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .model{
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: transparent;
        z-index: 100;
    }
    .box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: inline-block;
        width: 2rem;
        height: 2rem;
        border-radius: 10px;
        font-size: 30px;
        padding: .2rem;
        color: rgba(255, 255, 255, 0.5);
        box-sizing: border-box;
        vertical-align: top;
        -webkit-transition: .3s color, .3s border;
        transition: .3s color, .3s border;
        background-color:rgba(0, 0, 0, 0.5);
    }
    .box>div{
        text-align: center;
    }
    .box p{
        display: block;
        font-size: .28rem;
        color: #fff;
        text-align: center;
        margin-top: .3rem;
    }
    .box:hover {
        color: #d60b52;
        font-size: 0;
        padding: 0;
        border-width: 3px;
        line-height: 200px;
    }
    .box:hover [class*="loader-"] {
        font-size: 70px;
        line-height: 200px;
    }
    [class*="loader-"] {
        display: inline-block;
        width: 1em;
        height: 1em;
        color: inherit;
        vertical-align: middle;
        pointer-events: none;
    }
    .loader-05 {
        border: .2em solid transparent;
        border-top-color: currentcolor;
        border-radius: 50%;
        -webkit-animation: 1s loader-05 linear infinite;
        animation: 1s loader-05 linear infinite;
        position: relative;
    }
    .loader-05:before {
        content: '';
        display: block;
        width: inherit;
        height: inherit;
        position: absolute;
        top: -.2em;
        left: -.2em;
        border: .2em solid currentcolor;
        border-radius: 50%;
        opacity: .5;
    }
    @-webkit-keyframes loader-05 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes loader-05 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/loading.vue